'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Takes an array of objects and normalizes into an Immutable Map
 * using the provided idField as the key
 * @param  {String} uidField - name of the id field in the object
 * @param  {Immutable.List} data - List of Maps
 *
 * @return {Immutable.Map} - Map of normalized data
 */
var normalize = function normalize(uidField, data) {
  return _immutable2.default.Map(data.map(function (i) {
    return [i.get(uidField).toString(), i];
  }));
};

exports.default = normalize;